import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import Link from 'react-router-dom/Link';
import {Helmet} from 'react-helmet';
import {withRouter} from 'react-router-dom';
import connect from 'react-redux/es/connect/connect';
import {withLocalize, Translate} from 'react-localize-redux';
import translations from '../../../translations/translations_schools';
import SectionTitle from '../../../../Layout/components/SectionTitle';
import Button from '@material-ui/core/Button';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import {getSchool} from '../../../../Schools/actions';
import isEmpty from "../../../../../app/utils/isEmpty";
import LoadingSpinner from '../../../../Layout/components/LoadingSpinner';
import DashboardSchoolDetails from "./DashboardSchoolDetails";

class DashboardSchoolDetailsContainer extends Component {
    constructor(props) {
        super(props);

        this.props.addTranslation(translations);
    }

    fetchContent() {
        let slug = this.props.match.params.slug;

        this.props.getSchool(slug);
    }

    componentDidMount() {
        this.fetchContent();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.languages !== this.props.languages) {
            this.props.history.push('/dashboard/schools');
        }
    }

    render() {
        const {school, loading} = this.props;

        let pageTitle = 'Mes écoles' + ' ' + process.env.REACT_APP_HEAD_TITLE_SEPARATOR + ' ' + process.env.REACT_APP_SITE_TITLE;

        let output = null;

        if (isEmpty(school) || loading) {
            output = <LoadingSpinner align="center" />;
        } else {
            output = <DashboardSchoolDetails school={school}/>;
            pageTitle += ' | ' + school.title;
        }

        return (
            <Fragment>
                <Helmet
                    bodyAttributes={{
                        class: 'dashboard dashboard-school'
                    }}
                >
                    <title>{pageTitle}</title>
                </Helmet>
                <div className="container">
                    <SectionTitle cssClass="page-title"
                                  title={this.props.translate('dashboard_schools.page_title')}
                                  subtitle={this.props.translate('dashboard_schools.page_description')}
                    />
                    <div className="mt-90 mb-90">
                        <Button size="medium" className="btnBack" component={props => <Link to="/dashboard/schools" {...props}/>}>
                            <KeyboardBackspaceIcon className="btnIcon" />
                            <Translate id="dashboard_schools.button_back" />
                        </Button>

                        {output}
                    </div>
                </div>
            </Fragment>
        );
    }
}

DashboardSchoolDetailsContainer.propTypes = {
    getSchool: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    school: state.schools.school,
    loading: state.schools.schoolLoading,
    errors: state.schools.schoolErrors,
});

export default withRouter(connect(mapStateToProps, {getSchool})(withLocalize(DashboardSchoolDetailsContainer)));



// WEBPACK FOOTER //
// ./src/features/Dashboard/components/Schools/Details/DashboardSchoolDetailsContainer.js